import { createVanIconComponent } from "./van"

const Pause = createVanIconComponent("pause")
export default Pause
